import { render, staticRenderFns } from "./ReportColumnDescription.vue?vue&type=template&id=2c75ba59&scoped=true"
import script from "./ReportColumnDescription.vue?vue&type=script&lang=js"
export * from "./ReportColumnDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c75ba59",
  null
  
)

export default component.exports